// extracted by mini-css-extract-plugin
export default {"topicPill":"P8SM0zSb7t1vNNLZC7cu"};